import { atom } from "recoil";
import { AprovacaoSolicitacaoNaoPrevisto, SolicitacaoNaoPrevisto, UsuarioPermissaoSolicitacao } from "@app/api/naoPrevistos/solicitacao";
import moment from "moment";
import { newGuid } from "@app/helpers/generatorGuid";
import { IItemStep } from "@app/components/StepsPanel/interfaces";
import { OrcadoAnoNaoPrevisto } from "@app/api/naoPrevistos/parametros";
import { EStepsSolicitacaoNaoPrevisto } from "@app/enums/ENaoPrevisto";

const passoAtivoState = atom({
    key: 'passoAtivoState',
    default: {} as IItemStep,
});

export const solicitacaoState = atom({
    key: 'solicitacaoState',
    default: { id: newGuid(), ano: moment().year() } as SolicitacaoNaoPrevisto,
});

export const solicitacaoIdState = atom({
    key: 'solicitacaoIdState',
    default: undefined as string | undefined,
});

export const reloadState = atom({
  key: 'reloadState',
  default: true,
});

export const activeStepHashState = atom({
  key: 'activeStepHashState',
  default: EStepsSolicitacaoNaoPrevisto.DefinicaoDoTipoDaSolicitacao as string,
});

export const orcadoAnoParametroState = atom({
  key: 'orcadoAnoParametroState',
  default: {} as OrcadoAnoNaoPrevisto,
});

export const aprovacoesSolicitacaoState = atom({
  key: 'aprovacoesSolicitacaoState',
  default: [] as AprovacaoSolicitacaoNaoPrevisto[],
});

export const usuarioPermissaoState = atom({
  key: 'usuarioPermissaoState',
  default: {} as UsuarioPermissaoSolicitacao,
});